import { apiClient, handleResponse, handleError } from '../helpers';
import { api } from '../constants';
import {
    createRequestCacheKey,
    fetchWithCache,
    invalidateRequestCache,
} from '../helpers/requestCache';

const GAMES_TTL_MS = 2 * 60 * 1000;
const BLOCKED_STATUS_TTL_MS = 20 * 1000;

const gamesCacheKey = (studentId, gameMenu) => createRequestCacheKey('game', 'games', studentId, gameMenu);
const blockedStatusCacheKey = (studentId) => createRequestCacheKey('game', 'blocked-status', studentId);

export const gameService = {
    fetchGames,
    fetchBlockedStatus,
    purchaseGame,
    invalidateBlockedStatusCache,
};

function invalidateBlockedStatusCache(studentId) {
    if (studentId == null) {
        invalidateRequestCache(createRequestCacheKey('game', 'blocked-status'));
        return;
    }

    invalidateRequestCache(blockedStatusCacheKey(studentId));
}

function fetchGames(studentid, gameMenu, forceRefresh = false) {
    return fetchWithCache({
        key: gamesCacheKey(studentid, gameMenu),
        ttlMs: GAMES_TTL_MS,
        forceRefresh,
        loader: () => apiClient.get(`${api.games.fetchgames}/${studentid}/${gameMenu}`)
            .then(handleResponse)
            .then(data => data),
    })
        .catch(error => handleError(error.response));
}

function fetchBlockedStatus(studentid, forceRefresh = false) {
    return fetchWithCache({
        key: blockedStatusCacheKey(studentid),
        ttlMs: BLOCKED_STATUS_TTL_MS,
        forceRefresh,
        loader: () => apiClient.get(`${api.chatmessage.blockedStatus}/${studentid}`)
            .then(handleResponse)
            .then(data => data),
    })
        .catch(error => handleError(error.response));
}

function purchaseGame(payload) {
    return apiClient.post(api.games.purchaseGame, payload)
        .then(handleResponse)
        .then(data => {
            invalidateRequestCache([
                createRequestCacheKey('game', 'games'),
                createRequestCacheKey('profile', 'mypoints'),
            ]);
            return data;
        })
        .catch(error => handleError(error.response));
}
